var MediaQueryDispatch = require('./MediaQueryDispatch');
module.exports = new MediaQueryDispatch();



/*****************
 ** WEBPACK FOOTER
 ** ./~/.2.1.6@enquire.js/src/index.js
 ** module id = 445
 ** module chunks = 0 1
 **/